// components/progestao_compopnents/FilterControlsProgestao.js

import MenuPages from "../MenuPages";

import { useNavigate } from "react-router-dom";

// const normalizeString = (s) =>
//   s ? s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim().replace(/\s+/g, " ") : "";


const FilterControls = ({
  onDownloadNucleoCompleto,
  username,
  handleLogout,

  selectedTerritorio,
  setSelectedTerritorio,
  territoriosOptions,

  selectedMunicipio,
  setSelectedMunicipio,
  municipiosFiltrados,

  layersVisibility,
  setLayersVisibility,

  
  municipios,
  territorios,

  selectedUnidade,
  setSelectedUnidade,
  unidadesOptions,
  progestaoData
}) => {
  const toggleLayer = (layer) => {
    setLayersVisibility((prev) => ({
      ...prev,
      [layer]: !prev[layer],
    }));
  };

  const layerOptions = [
    { key: "unidades", label: "Unidades Administrativas", hasData: true }, // Forçamos true
    { key: "municipios", label: "Municípios", hasData: true },             // Forçamos true
    { key: "territorios", label: "Territórios", hasData: true },           // Forçamos true
  ];

  const navigate = useNavigate();

  
  return (
    <div style={{
      background: "#fff",
      padding: 20,
      gap: 30,
      borderRadius: 8,
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      width: 400
    }}>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <MenuPages navigate={navigate} />
        <button
          onClick={handleLogout}
          title="Sair"
          style={{
            padding: "4px 10px",
            background: "#c62828",
            color: "#fff",
            border: "none",
            borderRadius: 3,
            cursor: "pointer",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
        >
          Sair
        </button>
      </div>
      <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px", margin: "10px" }}>
        PAINEL PRO GESTÃO
      </div>
      
      

      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "8px 16px", margin: "0px", alignItems: "end" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <div style={{ margin: 0, padding: 0, height: "30px", fontSize: "14px", fontWeight: "bold" }}>
            {username && <p>Bem-vindo, <strong>{username}</strong>!</p>}
          </div>

          <label>Território:</label>
          <select value={selectedTerritorio} onChange={(e) => setSelectedTerritorio(e.target.value)}>
            {(territoriosOptions || []).map((terr) => (
              <option key={terr} value={terr}>{terr}</option>
            ))}
          </select>

          <label>Município:</label>
          <select value={selectedMunicipio} onChange={(e) => setSelectedMunicipio(e.target.value)}>
            {municipiosFiltrados.map((mun) => (
              <option key={mun} value={mun}>{mun}</option>
            ))}
          </select>

          <label>Unidade Administrativa:</label>
          <select
            value={selectedUnidade}
            onChange={(e) => setSelectedUnidade(e.target.value)}
            style={{ fontSize: '12px' }}
          >
            {(unidadesOptions || []).map((unid) => (
              <option key={unid} value={unid}>{unid}</option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 4, paddingBottom: 2 }}>
          <label style={{ fontWeight: "bold", fontSize: "11px", whiteSpace: "nowrap" }}>Exibir camadas:</label>
          {layerOptions.map(({ key, label, hasData }) =>
            hasData ? (
              <label key={key} style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "11px", whiteSpace: "nowrap" }}>
                <input
                  type="checkbox"
                  style={{ width: 11, height: 11, margin: 0 }}
                  checked={!!layersVisibility?.[key]}
                  onChange={() => toggleLayer(key)}
                />
                {label}
              </label>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterControls;
